import React, { useState } from 'react';
import HeatMap from './HeatMaps'
import Tranings from './Tranings';
import Skills from './Skills';

const ReportMain = () => {
   const [isOpen, setIsOpen] = useState(false);
    
      const toggleDropdown = () => setIsOpen(!isOpen);
      const [selected, setSelected] = useState('Candidate');
  
      const options = ['R123456789 ', 'Individual', 'Community', 'Cooperative'];
    
  return (
    <div>
        <div className='md:px-24 px-4'>
        <div className='flex justify-between items-center '>
<h1 className='md:text-[28px] text-[10px] font-bold text-[#03897B] mb-3'>REPORTS</h1>

<div>
    {/* Registration Number Section */}
    <div className="flex items-center ml-auto pr-2 md:pr-0  relative">
    <p className="md:text-[28px] text-[4px] bg-[#03897B] text-white px-2 md:px-4 md:w-[260px] md:h-[55px] md:py-[10px] py-[5px] md:rounded-tl-[5px] rounded-tl-md font-medium md:rounded-bl-[5px] rounded-bl-md text-center whitespace-nowrap">
      R123456789
    </p>
    <img
      src="https://res.cloudinary.com/dzngpgki4/image/upload/v1746113102/Expand_down_17_achr9o.png"
      alt="Expand"
      onClick={toggleDropdown}
      className="cursor-pointer w-[15px] h-[16px] md:h-[55px] md:w-[55px] md:-ml-2  -ml-1 object-contain bg-[#F38323] md:px-3 px-[3px] py-[1px] md:py-1 rounded-tr-[4px] rounded-[5px] md:rounded-tr-[5px] rounded-br-[4px] md:rounded-br-[5px]"
    />
    {/* Dropdown Menu */}
    {isOpen && (
      <div className="absolute top-full right-0 mt-1 py-2 flex justify-center items-center bg-white border border-gray-400 rounded shadow-md z-10 text-[5px] md:text-[18px] w-[60px] md:w-[220px] md:h-[300px]">
        <div>
          <h1 className="md:text-[20px] text-[6px] md:px-2 font-bold md:mb-5">DUE DILIGENCE</h1>
          {options.map((option, idx) => (
            <div key={idx}>
              <p className="px-2 py-1 md:py-2 hover:bg-gray-100 cursor-pointer">{option}</p>
            </div>
          ))}
        </div>
      </div>
    )}
  </div>
  <p className="md:text-[16px] text-[4px] font-light md:mb-3 mb-2 mt-1">Enter Registration number</p>
</div>
        </div>
        <p className='md:text-[24px] font-normal text-[8px] '>
        Ad-Luck Enterprise Reports generally provide: Business performance summaries (sales, profit, loss), Operational updates (production volumes, supply chain efficiency),Financial reports (budgets, expenditures, income analysis), Market analysis (trends, pricing, customer feedback), Recommendations for improvement in enterprise management.
        These reports help track progress, ensure accountability, and guide decision-making in farming or small business ventures. They are often used by project managers, donors, or agricultural training programs.
        </p>
        </div>
           <HeatMap/>
<Tranings/>
<Skills/>
    </div>
  )
}

export default ReportMain